import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const ProfileHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Profile</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default ProfileHeader;
